const dialogTriggerEl = document.querySelectorAll(".size-guide-trigger");
const dialogTriggerCloseEl = document.querySelectorAll(".size-guide-dialog-close");
const dialogTriggerContainerCloseEl = document.querySelectorAll(".size-guide-dialog");
const dialogContentEl = document.querySelectorAll(".size-guide-dialog-content");

dialogTriggerEl.forEach(element => {
  const dialogElParent = element.closest('.image-with-text__content');
  const dialogEl = dialogElParent.querySelector('.size-guide-dialog')

  element.addEventListener('click', function() {
    dialogEl.showModal();
    dialogEl.classList.add('open');
    document.body.classList.add('overflow-hidden');
  })
});

dialogTriggerCloseEl.forEach(element => {
  const dialogElParent = element.closest('.image-with-text__content');
  const dialogEl = dialogElParent.querySelector('.size-guide-dialog')

  element.addEventListener('click', function() {
    dialogEl.close();
    dialogEl.classList.remove('open');
    document.body.classList.remove('overflow-hidden');
  })
});

dialogTriggerContainerCloseEl.forEach(element => {
  const dialogElParent = element.closest('.image-with-text__content');
  const dialogEl = dialogElParent.querySelector('.size-guide-dialog')

  element.addEventListener('click', function(e) {
    if (e.target === element) {
      dialogEl.close();
      dialogEl.classList.remove('open');
      document.body.classList.remove('overflow-hidden');
    }
  })
});
